export const API_KEY = "AIzaSyDgh6GOhl83LxQkfIBU6gM3es3ik0hDsbY";

export default API_KEY;